import React, {useEffect, useReducer, useState} from 'react';
import clsx from "clsx";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import {Badge, Paper} from "@mui/material";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import EventTwoToneIcon from '@mui/icons-material/EventTwoTone';
import EventAvailableTwoToneIcon from '@mui/icons-material/EventAvailableTwoTone';
import Filter1TwoToneIcon from '@mui/icons-material/Filter1TwoTone';
import Filter2TwoToneIcon from '@mui/icons-material/Filter2TwoTone';
import Filter3TwoToneIcon from '@mui/icons-material/Filter3TwoTone';
import PanToolTwoToneIcon from '@mui/icons-material/PanToolTwoTone';
import DriveEtaTwoToneIcon from '@mui/icons-material/DriveEtaTwoTone';
import NightsStayTwoToneIcon from '@mui/icons-material/NightsStayTwoTone';
import AddToQueueTwoToneIcon from '@mui/icons-material/AddToQueueTwoTone';
import FiberManualRecordTwoToneIcon from '@mui/icons-material/FiberManualRecordTwoTone';
import {initQuaranteneState, QUARANTENE_INITIAL_STATE, QuaranteneReducer} from "../../../../reducers/QuaranteneReducer";
import {getAllInfoQuarantene} from "../../../../services/QuaranteneServices";
import {tipologieQuarantena} from "../../../../utils/arrays/Generics";
import BathtubTwoToneIcon from "@mui/icons-material/BathtubTwoTone";
import TodayTwoToneIcon from '@mui/icons-material/TodayTwoTone';
import MarkunreadMailboxTwoToneIcon from '@mui/icons-material/MarkunreadMailboxTwoTone';
import RateReviewTwoToneIcon from '@mui/icons-material/RateReviewTwoTone';
import EventSeatTwoToneIcon from '@mui/icons-material/EventSeatTwoTone';
import Typography from "@mui/material/Typography";


const QuaranteneDrawer = ({
	                          selectMenuItem,
	                          stato,
	                          filters,
	                          setFilters,
	                          filtersMonitoraggio,
	                          setMenuFilterMonitoraggio,
	                          scoreFilter,
	                          setScoreFilter,
	                          type,
	                          handleTypeOfDate,
	                          active, setActive,
	                          ageFilter, setAgeFilter
                          }) => {
	const classes = BaseStyle();
	const [state, dispatch] = useReducer(QuaranteneReducer, QUARANTENE_INITIAL_STATE, initQuaranteneState);
	
	const [open, setOpen] = useState(true);
	
	const handleDrawerOpenClose = () => {
		setOpen(!open);
	};
	
	useEffect(() => {
		let data = {};
		if (stato && stato !== "IN GESTIONE") data = {...data, stato: stato}
		if (active) {
			data = {...data, active: true}
		} else {
			data = {...data, active: null}
		}
		if (filtersMonitoraggio === "Compilato giornaliero") {
			data = {...data, compilatoMonitoraggioGiornaliero: true}
		} else {
			data = {...data, compilatoMonitoraggioGiornaliero: null}
		}
		if (filters) data = {...data, tipo: filters}
		if (filtersMonitoraggio && filtersMonitoraggio !== "Compilato giornaliero") data = {
			...data,
			tipoMonitoraggio: filtersMonitoraggio
		}
		if (scoreFilter) data = {...data, score: scoreFilter}
		getAllInfoQuarantene(dispatch, data);
	}, [dispatch, stato, filters, filtersMonitoraggio, scoreFilter, active])
	
	return (
        <React.Fragment>
            <Paper
				className={clsx(classes.drawerBig, classes.roundBorder, open ? classes.openDrawer : classes.closedDrawer)}>
				<div style={{display: "flex", justifyContent: "center"}}>
					<Tooltip title={open ? "Comprimi menù" : "Espandi menù"}>
						<IconButton onClick={handleDrawerOpenClose} size="large">
							{!open ? <ChevronRightIcon/> : <ChevronLeftIcon/>}
						</IconButton>
					</Tooltip>
				</div>
				{
					type && <React.Fragment>
						<List subheader={
							<Typography color={"textSecondary"} style={{paddingLeft: 6}}>
								Filtri che applichi solo nel giorno
							</Typography>
						}>
							<ListItem button className={classes.roundBorder} selected={type === "dataInizio"}
							          onClick={() => handleTypeOfDate("dataInizio")}>
								<ListItemIcon>
									<TodayTwoToneIcon/>
								</ListItemIcon>
								<ListItemText primary={"Data inizio"}/>
							</ListItem>
							<ListItem button className={classes.roundBorder} selected={type === "dataFine"}
							          onClick={() => handleTypeOfDate("dataFine")}>
								<ListItemIcon>
									<MarkunreadMailboxTwoToneIcon/>
								</ListItemIcon>
								<ListItemText primary={"Data fine"}/>
							</ListItem>
							<ListItem button className={classes.roundBorder} selected={type === "ultimoMonitoraggio"}
							          onClick={() => handleTypeOfDate("ultimoMonitoraggio")}>
								<ListItemIcon>
									<RateReviewTwoToneIcon/>
								</ListItemIcon>
								<ListItemText primary={"Ultimo monitoraggio"}/>
							</ListItem>
						</List>
						<Divider/>
					</React.Fragment>
				}
				<List>
					<ListItem button className={classes.roundBorder} selected={stato === "NUOVA"}
					          onClick={() => selectMenuItem("NUOVA")}>
						<ListItemIcon>
							<Badge badgeContent={state.allInfo?.["Nuove"]} showZero color="primary" max={99999}>
								<EventTwoToneIcon/>
							</Badge>
						</ListItemIcon>
						<ListItemText primary={"Nuova"}/>
					</ListItem>
					<ListItem button className={classes.roundBorder} selected={stato === "IN ATTESA"}
					          onClick={() => selectMenuItem("IN ATTESA")}>
						<ListItemIcon>
							<Badge badgeContent={state.allInfo?.["In attesa"]} showZero color="primary" max={99999}>
								<EventTwoToneIcon/>
							</Badge>
						</ListItemIcon>
						<ListItemText primary={"In attesa"}/>
					</ListItem>
					<ListItem button className={classes.roundBorder} selected={stato === "IN CORSO"}
					          onClick={() => selectMenuItem("IN CORSO")}>
						<ListItemIcon>
							<Badge badgeContent={state.allInfo?.["In corso"]} showZero color="primary" max={9999}>
								<EventTwoToneIcon/>
							</Badge>
						</ListItemIcon>
						<ListItemText primary={"In corso"}/>
					</ListItem>
					<ListItem button className={classes.roundBorder} selected={stato === "GUARITO"}
					          onClick={() => selectMenuItem("GUARITO")}>
						<ListItemIcon>
							<Badge badgeContent={state.allInfo?.["Guarito"]} showZero color="primary" max={9999}>
								<AddToQueueTwoToneIcon/>
							</Badge>
						</ListItemIcon>
						<ListItemText primary={"Da guarire su GP"}/>
					</ListItem>
					<ListItem button className={classes.roundBorder} selected={stato === "CONCLUSA"}
					          onClick={() => selectMenuItem("CONCLUSA")}>
						<ListItemIcon>
							<Badge badgeContent={state.allInfo?.["Concluse"]} showZero color="primary" max={999999}>
								<EventAvailableTwoToneIcon/>
							</Badge>
						</ListItemIcon>
						<ListItemText primary={"Concluse / Guariti GP"}/>
					</ListItem>
				</List>
				
				<Divider/>
				<List>
					<ListItem button className={classes.roundBorder} selected={active === true}
					          onClick={() => setActive(!active)}>
						<ListItemIcon>
							<Badge badgeContent={state.allInfo?.["In gestione"]} showZero color="primary" max={999}>
								<BathtubTwoToneIcon/>
							</Badge>
						</ListItemIcon>
						<ListItemText primary={"In gestione"}/>
					</ListItem>
				</List>
				<Divider/>
				<Divider/>
				<List>
					<ListItem button className={classes.roundBorder} selected={ageFilter === true}
					          onClick={() => setAgeFilter(ageFilter ? null : true)}>
						<ListItemIcon>
							<Badge badgeContent={state.allInfo?.["Over 65"]} showZero color="primary" max={999}>
								<EventSeatTwoToneIcon/>
							</Badge>
						</ListItemIcon>
						<ListItemText primary={"Over 65"}/>
					</ListItem>
				</List>
				<Divider/>
				<List>
					{
						tipologieQuarantena.map((tipo, index) => {
							return (
								<ListItem key={index} button className={classes.roundBorder} selected={filters === tipo}
								          onClick={() => setFilters(filters === tipo ? "" : tipo)}>
									<ListItemIcon>
										<Badge badgeContent={state.allInfo?.[tipo]} showZero color="primary" max={9999}>
											{index === 0 &&
												<Badge badgeContent={state.allInfo?.["Isolamenti"]} showZero color="primary" max={99999}>
													<Filter1TwoToneIcon/>
												</Badge>
											}
											{index === 1 &&
												<Badge badgeContent={state.allInfo?.["Quarantene"]} showZero color="primary" max={99999}>
													<Filter2TwoToneIcon/>
												</Badge>
											}
											{index === 2 &&
												<Badge badgeContent={state.allInfo?.["Isolamento - comunità"]} showZero color="primary"
												       max={99999}>
													<Filter3TwoToneIcon/>
												</Badge>
											}
											{index === 3 &&
												<Badge badgeContent={state.allInfo?.["Quarantena - comunità"]} showZero color="primary"
												       max={99999}>
													<Filter3TwoToneIcon/>
												</Badge>
											}
											
											
											{/*{index === 2 && <Filter3TwoToneIcon/>}
											{index === 3 && <Filter4TwoToneIcon/>}
											{index === 4 && <Filter5TwoToneIcon/>}
											{index === 5 && <Filter6TwoToneIcon/>}
											{index === 6 && <Filter7TwoToneIcon/>}
											{index === 7 && <Filter7TwoToneIcon/>}*/}
										</Badge>
									</ListItemIcon>
									<ListItemText primary={tipo === "Quarantena" ? "Autosorveglianza" : tipo}
									              style={{width: 190, whiteSpace: "pre-wrap"}}/>
								</ListItem>
							)
						})
					}
				</List>
				<Divider/>
				
				<List>
					<ListItem button className={classes.roundBorder} selected={filtersMonitoraggio === "Manuale"}
					          onClick={() => setMenuFilterMonitoraggio(filtersMonitoraggio === "Manuale" ? "" : "Manuale")}>
						<ListItemIcon>
							<Badge badgeContent={state.allInfo?.["Monitoraggio Manuale"]} showZero color="primary" max={99999}>
								<PanToolTwoToneIcon/>
							</Badge>
						</ListItemIcon>
						<ListItemText primary={"Monitoraggio manuale"}/>
					</ListItem>
					<ListItem button className={classes.roundBorder} selected={filtersMonitoraggio === "Automatico"}
					          onClick={() => setMenuFilterMonitoraggio(filtersMonitoraggio === "Automatico" ? "" : "Automatico")}>
						<ListItemIcon>
							<Badge badgeContent={state.allInfo?.["Monitoraggio Automatico"]} showZero color="primary" max={99999}>
								<DriveEtaTwoToneIcon/>
							</Badge>
						</ListItemIcon>
						<ListItemText primary={"Monitoraggio automatico"}/>
					</ListItem>
				</List>
				
				<Divider/>
				<List>
					<ListItem button className={classes.roundBorder} selected={filtersMonitoraggio === "Compilato giornaliero"}
					          onClick={() => setMenuFilterMonitoraggio(filtersMonitoraggio === "Compilato giornaliero" ? "" : "Compilato giornaliero")}>
						<ListItemIcon>
							<Badge badgeContent={state.allInfo?.["Compilato giornaliero"]} showZero color="primary" max={99999}>
								<NightsStayTwoToneIcon/>
							</Badge>
						</ListItemIcon>
						<ListItemText primary={"Compilato giornaliero"}/>
					</ListItem>
				</List>
				
				<Divider/>
				
				<List>
					<ListItem button className={classes.roundBorder} selected={scoreFilter === "0"}
					          onClick={() => setScoreFilter(scoreFilter === "0" ? "" : "0")}>
						<ListItemIcon>
							<FiberManualRecordTwoToneIcon/>
						</ListItemIcon>
						<ListItemText primary={"SCORE 0"}/>
					</ListItem>
					<ListItem button className={classes.roundBorder} selected={scoreFilter === "1"}
					          onClick={() => setScoreFilter(scoreFilter === "1" ? "" : "1")}>
						<ListItemIcon>
							<FiberManualRecordTwoToneIcon/>
						</ListItemIcon>
						<ListItemText primary={"SCORE 1"}/>
					</ListItem>
					<ListItem button className={classes.roundBorder} selected={scoreFilter === "2"}
					          onClick={() => setScoreFilter(scoreFilter === "2" ? "" : "2")}>
						<ListItemIcon>
							<FiberManualRecordTwoToneIcon/>
						</ListItemIcon>
						<ListItemText primary={"SCORE 2"}/>
					</ListItem>
					<ListItem button className={classes.roundBorder} selected={scoreFilter === "3"}
					          onClick={() => setScoreFilter(scoreFilter === "3" ? "" : "3")}>
						<ListItemIcon>
							<FiberManualRecordTwoToneIcon/>
						</ListItemIcon>
						<ListItemText primary={"SCORE 3"}/>
					</ListItem>
					<ListItem button className={classes.roundBorder} selected={scoreFilter === "4"}
					          onClick={() => setScoreFilter(scoreFilter === "4" ? "" : "4")}>
						<ListItemIcon>
							<FiberManualRecordTwoToneIcon/>
						</ListItemIcon>
						<ListItemText primary={"SCORE 4"}/>
					</ListItem>
				</List>
			</Paper>
        </React.Fragment>
    );
};

export default React.memo(QuaranteneDrawer)
